import { isString } from '../shared/runtime-values.js';
import { AUTOCOMPLETE_REQUEST_SUPERSEDED } from './abort-reasons.js';

const NON_APP_SOURCE_PATTERNS = [
  /(?:^|[^\w-])(?:chrome|moz|safari-web)-extension:\/\//,
  /^https:\/\/static\.cloudflareinsights\.com\/beacon\.min\.js(?:\/|\?|$)/,
  /^https:\/\/zerophishing\.iaas\.checkpoint\.com\/\d+\/zp\.js(?:\?|$)/,
];

export function isKnownNonAppErrorSource(source: string | undefined): boolean {
  if (!source) return false;
  return NON_APP_SOURCE_PATTERNS.some((pattern) => pattern.test(source));
}

export function isKnownCrawlerUserAgent(userAgent: string): boolean {
  return /\b(?:Yandex[A-Za-z]*Bot|YandexUserproxy|YisouSpider)\b/i.test(userAgent);
}

export function isKnownNonAppRuntimeError(message: string, userAgent = navigator.userAgent, source?: string): boolean {
  if (isKnownNonAppErrorSource(source)) return true;
  if (message === AUTOCOMPLETE_REQUEST_SUPERSEDED) return true;
  if (message.includes('appSettingsDistributor')) return true;
  if (message.includes('response.cashbackReminder')) return true;
  if (message === 'undefined' || message === '[App Error] undefined') return true;
  if (message === 'Script error.' && (!source || source === 'unknown')) return true;
  if (/^Object Not Found Matching Id:\d+, MethodName:update, ParamCount:\d+$/.test(message)) return true;
  if (/^\[App Error\] Object Not Found Matching Id:\d+, MethodName:update, ParamCount:\d+/.test(message)) return true;
  if (message === 'Geolocation error:') return true;
  if (message.startsWith('An error occurred while rendering.  Rendering has stopped.')) return true;
  if (message.startsWith('Failed to fetch auth state:') && isKnownCrawlerUserAgent(userAgent)) return true;
  if (/^(?:TypeError: )?Failed to fetch$/.test(message) && isKnownCrawlerUserAgent(userAgent)) return true;
  if (/^(?:Fetch request failed|Error processing response text): AbortError:/.test(message)) return true;
  if (message === "ReferenceError: Can't find variable: _G" && /\bBingSapphire\//.test(userAgent)) return true;
  if (message === "'' is not a valid selector." && /\bDdg\//.test(userAgent)) return true;
  if (message === 'ResizeObserver loop completed with undelivered notifications.') return true;
  return false;
}

export function isKnownNonAppErrorStack(stack: string | undefined): boolean {
  return isString(stack) && isKnownNonAppErrorSource(stack);
}
